import { WhatsIncludedItem } from '@/components/ChooseVoyage/WhatsIncludedItem/WhatsIncludedItem';
import { selectSailingData } from '@/ducks/voyageInfo/sailing/selectors';
import { FormattedMessage } from '@/helpers/formatted-message';
import { checkForValueType } from '@/helpers/util';
import { useAppSelector } from '@/store';

import './WhatsIncluded.scss';

const WhatsIncluded = () => {
  const whatsIncluded = useAppSelector((state) => selectSailingData(state)?.whatsIncluded);
  return (
    <div className="WhatsIncludedNew">
      <div className="IncludeHeading">
        <FormattedMessage defaultMessage="Always Included Luxury" id="Itinerary.Included.heading" />
      </div>
      <div className="IncludeSubHeading">
        <FormattedMessage
          defaultMessage="We’ve taken care of all the details — so all you have to do is kick back and have the relaxing vacation you deserve. Everything below is included."
          id="Itinerary.Included.subheading"
        />
      </div>
      <div className="WhatsIncludedRows">
        {checkForValueType(whatsIncluded) &&
          whatsIncluded.map((feature, index) => (
            <WhatsIncludedItem feature={feature} key={`${feature?.text} ${index}`} />
          ))}
      </div>
    </div>
  );
};

export default WhatsIncluded;
